export const environment = {
  production: true,
  // webApiHost: 'https://automationstudio.kpmgservices.tech/spotlightApi',
  // hostname: 'https://automationstudio.kpmgservices.tech/spotlight',
  webApiHost: '#{PLACEHOLDER_FRR_URL_API}#',
  hostname: '#{PLACEHOLDER_FRR_URL_WEB}#',
  apiBaseUrl: '#{PLACEHOLDER_FRR_URL_WEB}#',
  apiUrl: '#{PLACEHOLDER_FRR_URL_API}#',
  enableTax: '#{PLACEHOLDER_FRR_ENABLE_TAX}#',
  preservationDays: 5,
  azure: {
    isCloud: 'true', // 'true' or 'false'
    tenant: '#{PLACEHOLDER_FRR_TENANT_ID}#', // Tenant ID
    clientId: '#{PLACEHOLDER_FRR_CLIENT_ID}#',
    // Client ID
    endpoints: {
      '#{PLACEHOLDER_FRR_URL_API}#': '#{PLACEHOLDER_FRR_CLIENT_ID}#',
      '#{PLACEHOLDER_FRR_URL_WEB}#': '#{PLACEHOLDER_FRR_CLIENT_ID}#'

    }
  },
  EVSUserGuideName: "Intangible Spotlight Userguide.pdf",
  projectNav: [
    // {
    //   title: 'Home',
    //   icon: 'fa fa-home',
    //   url: ''
    // },
    {
      title: '1',
      icon: '',
      url: '/evs'
    }
    ,
    {
      title: '2',
      icon: '',
      url: '/tax'
    }
  ],
  adminNav: [

    {
      title: '',
      icon: 'fa fa-cog',
      url: '/admin'
    }

  ],
  adminTiles: [

    {
      title: 'Intangible Spotlight',
      description: 'Set Up Or Modify Intangible , Purchase Price Categories And Mapping.',
      url: '/admin/evs'
    },
    {
      title: '10-K Spotlight',
      description: 'Set Up Or Modify BalanceSheet, Income Statement, Income Tax Disclosure Categories.',
      url: '/admin/tax'
    },
    {
      title: 'USERS',
      description: 'To Add, Provision Users And Assign Admin Role.',
      url: '/admin/user'
    },
    {
      title: 'Audit',
      description: 'To Track Changes Made.',
      url: '/admin/audit'
    },
    // {
    //   title: 'Extraction Details',
    //   description: 'To Track Extraction Details',
    //   url: '/admin/extraction'
    // }
    {
      title: 'Utilities',
      description: 'To track , perform extraction and set up application info.',
      url: '/admin/utilities'
    },
    {
      title: 'CapIQ - Utilities',
      description: 'To track , perform extraction and set up CapIQ info.',
      url: '/admin/ciqutilities'
    }
    // {
    //   title: 'TEMPLATE',
    //   description: 'To Upload Power BI Template.',
    //   url: '/admin/template'
    // }


  ],
  supportMail: {
    mail: 'us-taxevsintspotsup@kpmg.com',
    subject: 'Intangibles Spotlight Support'
  },
  supportMailTax: {
    mail: 'us-tax10kspotlight@kpmg.com',
    subject: '10K Spotlight Support'
  },
  maxClientSearchResults: 20,
  cssRootUrl: '/spotlight/css',
  minPeriodEndYear: 2015,
  filterFields: {
    Clause: ["AND", "OR"],
    EVS: [{
      fieldName: "Company",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    },
    {
      fieldName: "Acquired Company",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    },
    {
      fieldName: "Industry",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    },
    {
      fieldName: "Total Purchase Price",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "number"
    },
    //{
    //  fieldName: "Total Intangibles",
    //  operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
    //  value: "number"
    //},
    {
      fieldName: "Total Goodwill",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "number"
    },
    {
      fieldName: "Year",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "year"
    }
        /* {
          fieldName: "Keyword Search",
          operators: ["Contains"],
          value: "text"
        } */],
    TAX: [{
      fieldName: "Company",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    },
    {
      fieldName: "Industry",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    },
    {
      fieldName: "Total Revenue",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "number"
    },
    {
      fieldName: "Total Assets",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "number"
    },
    {
      fieldName: "PreTax Book Income",
      operators: ["Equals", "Not Equal to", "Less Than", "Less than or Equal To", "Greater Than", "Greater than or Equal To"],
      value: "number"
    }/*,
    {
      fieldName: "Keyword Search",
      operators: ["Contains", "StartsWith", "EndsWith"],
      value: "text"
    }*/]
  },
  EVSReports: [
    {
      id: '1',
      icon: 'fa fa-file-o',
      type: 'Power BI',
      code: 'powerbi'
    },
    {
      id: '2',
      icon: 'fa fa-file-archive-o',
      type: 'ZipExtract',
      code: 'zip'
    },
    /*   {
         id: '3', 
         icon: 'fa fa-file-pdf-o', 
         type: 'PDF'
       }, */
    {
      id: '4',
      icon: 'fa fa-file-excel-o',
      type: 'Excel',
      code: 'excel'
    }
  ],
  TAXReports: [
    {
      title: 'Company Digest',
      code: 'companydigest',
      report: [
        { id: '1', icon: 'fa fa-file-excel-o', type: 'PDF' },
        { id: '2', icon: 'fa fa-file-pdf-o', type: 'Excel' },
        { id: '3', icon: 'fa fa-file-word-o', type: 'Word' }
      ]
    },
    {
      title: 'Appendix',
      code: 'appendix',
      report: [
        { id: '1', icon: 'fa fa-file-excel-o', type: 'PDF' },
        { id: '2', icon: 'fa fa-file-word-o', type: 'Word' }
      ]
    },
    {
      title: 'Financial Statements And Footnote Extraction',
      code: 'financialstatementdatabase',
      report: [

        { id: '1', icon: 'fa fa-file-word-o', type: 'Word' }
      ]
    },
    {
      title: 'Keyword Search Results',
      code: 'keywordsearchresults',
      report: [

        { id: '1', icon: 'fa fa-file-word-o', type: 'Word' }
      ]
    },
    {
      title: 'Benchmarking',
      code: 'benchmarking',
      report: [
        { id: '1', icon: 'fa fa-file-o', type: 'Power BI' },
        { id: '2', icon: 'fa fa-file-pdf-o', type: 'Excel' }
      ]
    },
    {
      title: 'Trending Analysis',
      code: 'trendanalysis',
      report: [
        { id: '1', icon: 'fa fa-file-o', type: 'Power BI' },
        { id: '2', icon: 'fa fa-file-pdf-o', type: 'Excel' }
      ]
    }
  ]

};
